/*
 * @Author: yuanyunpeng 15226551376@163.com
 * @Date: 2023-05-19 11:18:26
 * @LastEditors: zhaoyanpeng 2235576749@qq.com
 * @LastEditTime: 2023-07-15 11:20:23
 * @FilePath: \web\src\router\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Router from 'vue-router';
import store from '../store';
import { getToken } from '@/utils/auth';

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'home',
      // component: HelloWorld
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../view/login/Index.vue'),
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('../view/home/Home.vue'),
    },
    {
      path: '/order',
      name: 'Order',
      component: () => import('../view/order/Index.vue'),
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('../view/order/payment.vue'),
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('../view/news/Index.vue'),
    },
    {
      path: '/system',
      name: 'System',
      component: () => import('../view/system/Index.vue'),
    },
    {
      path: '/solutionPage',
      name: 'solutionPage',
      component: () => import('../view/solution/solution.vue'),
      redirect: 'solutionPage/main',
      children: [
        {
          path: 'main',
          name: 'main',
          component: () => import('../view/solution/main.vue'),
        },
        {
          path: 'catering',
          name: 'catering',
          component: () => import('../view/solution/catering.vue'),
        },
        {
          path: 'manufacturesolution',
          name: 'ManufactureSolution',
          component: () => import('../view/solution/detail/ManufactureSolution.vue'),
        },
        {
          path: 'commwisdom',
          name: 'Commwisdom',
          component: () => import('../view/commwisdom/index.vue'),
        },
      ],
    },
    {
      path: '/solutionMain',
      name: 'main',
      component: () => import('../view/solution/main.vue'),
    },
    {
      path: '/catering',
      name: 'catering',
      component: () => import('../view/solution/catering.vue'),
    },
    {
      path: '/solution',
      name: 'Solution',
      redirect: 'solution/trade',

      component: () => import('../view/solution/Index.vue'),
      children: [
        {
          path: 'trade',
          name: 'Trade',
          component: () => import('../view/solution/content/Trade.vue'),
        },
        {
          path: 'soft',
          name: 'Soft',
          component: () => import('../view/solution/content/Soft.vue'),
        },
        {
          path: 'equip',
          name: 'Equip',
          component: () => import('../view/solution/content/Equip.vue'),
        },
      ],
    },
    {
      path: '/commoditydetail',
      name: 'CommodityDetail',
      component: () => import('../view/detail/commodity/Index.vue'),
    },
    {
      path: '/servicedetail',
      name: 'ServiceDetail',
      component: () => import('../view/detail/service/Index.vue'),
    },
    {
      path: '/solutiondetail',
      name: 'SolutionDetail',
      component: () => import('../view/solution/content/SolutionDetail.vue'),
    },
    {
      path: '/addsolution',
      name: 'AddSolution',
      component: () => import('../view/solution/AddSolution.vue'),
    },

    //制造行业解决方案
    {
      path: '/manufacturesolution',
      name: 'ManufactureSolution',
      component: () => import('../view/solution/detail/ManufactureSolution.vue'),
    },
    {
      path: '/addwait',
      name: 'AddWait',
      component: () => import('../view/solution/AddWait.vue'),
    },
    {
      path: '/shopcart',
      name: 'ShopCart',
      component: () => import('../view/order/ShopCart.vue'),
    },
    {
      path: '/enterprise',
      name: 'Enterprise',
      component: () => import('../view/enterpirse/Index.vue'),
    },
    // 培训学员
    {
      path: '/institute',
      name: 'Institute',
      // redirect: 'institute/insindex',
      component: () => import('../view/institute/content/Index.vue'),
    },

    // 人才大厅
    {
      path: '/abilitypeople',
      name: 'AbilityPeople',
      // redirect: 'institute/insindex',
      component: () => import('../view/abilitypeople/Index.vue'),
    },
    // 产业AI
    {
      path: '/industrialAI',
      name: 'industrialAI',
      component: () => import('../view/industrialAI/index.vue'),
    },
    // 人才详情
    {
      path: '/talentdetails',
      name: 'TalentDetails',
      component: () => import('../view/abilitypeople/TalentDetails.vue'),
    },
    // 应用商店
    {
      path: '/appshop',
      name: 'AppShop',
      // redirect: 'institute/insindex',
      component: () => import('../view/appshop/Index.vue'),
    },

    // 课程列表
    {
      path: '/courselist',
      name: 'Courselist',
      component: () => import('../view/courselist/Index.vue'),
    },
    // 课程详情
    {
      path: '/coursedetails',
      name: 'Coursedetails',
      component: () => import('../view/coursedetails/index.vue'),
    },
    //  通用-下单页面（确定订单-选择支付方式-支付成功）
    {
      path: '/purchaseOrder',
      name: 'purchaseOrder',
      component: () => import('../view/common/purchaseOrder.vue'),
    },
    // 通用-扫码付款页面
    {
      path: '/paying',
      name: 'paying',
      component: () => import('../view/common/paying.vue'),
    },
    {
      path: '/settlement',
      name: 'Settlement',
      component: () => import('../view/settlement/Index.vue'),
    },
    {
      path: '/join',
      name: 'Join',
      component: () => import('../view/join/Index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    // 云会员填写基本信息
    {
      path: '/information',
      name: 'Information',
      component: () => import('../view/information/Index.vue'),
    },
    // 资料审核
    {
      path: '/review',
      name: 'Review',
      component: () => import('../view/review/Index.vue'),
    },
    // 开通店铺1
    {
      path: '/openshop',
      name: 'Openshop',
      component: () => import('../view/openshop/Index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    {
      path: '/demand',
      name: 'Demand',
      component: () => import('../view/demand/Index.vue'),
    },
    // 开通店铺2
    {
      path: '/storename',
      name: 'Storename',
      component: () => import('../view/storename/Index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    {
      path: '/Halldetails',
      name: 'Halldetails',
      component: () => import('../view/halldetails/Index.vue'),
    },
    // 需求大厅 需求管理里 新增 之后跳转页
    {
      path: '/newdemand',
      name: 'newdemand',
      component: () => import('../view/demandment/newdemand/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    {
      path: '/newdemands',
      name: 'newdemands',
      component: () => import('../view/demandment/newdemands/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    {
      path: '/newdemandt',
      name: 'newdemandt',
      component: () => import('../view/demandment/newdemandt/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    // 参与需求
    {
      path: '/mentdetails',
      name: 'Mentdetails',
      component: () => import('../view/mentdetails/Index.vue'),
    },
    {
      path: '/mentalter',
      name: 'Mentalter',
      component: () => import('../view/mentalter/Index.vue'),
    },

    // 工作台--->需求管理-->编辑
    {
      path: '/requirementso',
      name: 'Requirementso',
      component: () => import('../view/demanedit/newdemand/index.vue'),
      meta: {
        keepAlive: false, // 需要缓存false//不需要缓存
      },
    },
    // 2.
    {
      path: '/requirementst',
      name: 'Requirementst',
      component: () => import('../view/demanedit/newdemands/index.vue'),
      meta: {
        keepAlive: false, // 需要缓存false//不需要缓存
      },
    },
    // 3.
    {
      path: '/requirements',
      name: 'Requirements',
      component: () => import('../view/demanedit/newdemandt/index.vue'),
      meta: {
        keepAlive: false, // 需要缓存false//不需要缓存
      },
    },

    //发布类似需求
    {
      path: '/likeness',
      name: 'Likeness',
      component: () => import('../view/demandlike/newdemand/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    //
    {
      path: '/likenestwo',
      name: 'Likenestwo',
      component: () => import('../view/demandlike/newdemands/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    //3.
    {
      path: '/likenesthree',
      name: 'Likenesthree',
      component: () => import('../view/demandlike/newdemandt/index.vue'),
      meta: {
        keepAlive: true, // 需要缓存false//不需要缓存
      },
    },
    {
      path: '/worktable',
      name: 'worktable',
      component: () => import('../view/worktable/Index.vue'),
      redirect: 'worktable/workbench',
      meta: { title: '工作台' },
      children: [
        {
          path: 'workbench',
          name: 'workbench',
          component: () => import('../view/worktable/workbench/Index.vue'),
        },
        // 店铺设置
        {
          path: 'shopsetting',
          name: 'shopsetting',
          meta: { title: '店铺设置', hideIfFieldTrue: 'someField' },
          component: () => import('../view/shopsetting/Index.vue'),
        },
        // 消息通知
        {
          path: 'notification',
          name: 'notification',
          // meta: { title: "消息通知" },
          component: () => import('../view/notification/Index.vue'),
        },
      ],
    },
    // 需求管理
    {
      path: '/demandment',
      name: 'Demandment',
      meta: { title: '需求管理' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/demandment/demandManage',
      children: [
        {
          path: 'demandManage',
          name: 'demandManage',
          component: () => import('../view/demandment/Index.vue'),
          meta: {
            keepAlive: false,
          },
        },
        {
          path: 'popup',
          name: 'Popup',
          component: () => import('../view/popup/Index.vue'),
          meta: {
            title: '需求详情',
          },
        },
        {
          path: 'tender',
          name: 'Tender',
          component: () => import('../view/demandment/content/index.vue'),
          meta: {
            title: '需求详情',
          },
        },
        // 需求大厅 需求管理里 新增 之后跳转页
        {
          path: 'add',
          name: 'add',
          component: () => import('../view/demandment/add.vue'),
          meta: {
            title: '发布需求',
          },
        },
      ],
    },
    // 账号中心
    {
      path: '/account',
      name: 'account',
      meta: { title: '系统设置' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/account/accountSetting',
      children:[
        {
          path: 'accountSetting',
          name: 'AccountSetting',
          meta: { title: '账号中心' },
          component: () => import('../view/purchaseorder/Index.vue'),
        },
        {
          path: '/joination',
          name: 'Joination',
          meta: { title: '实名认证' },
          component: () => import('../view/openshop/Index.vue'),
        }
      ]
    },
    //订单管理
    {
      path: '/order_manage',
      name: 'order_manage',
      meta: { title: '订单管理' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/order_manage/provider',
      children: [
        // 服务商订单
        {
          path: 'provider',
          name: 'provider',
          meta: { title: '采购订单' },
          component: () => import('../view/provider/Index.vue'),
        },
        {
          path: 'sellOrder',
          name: 'sellOrder',
          meta: { title: '销售订单' },
          component: () => import('../view/provider/sellOrder.vue'),
        },
        //销售订单详情
        {
          path: 'orderDetail',
          name: 'orderDetail',
          meta: {
            title: '订单详情',
            parentTitle: '销售订单',
            parentPath: 'sellOrder',
          },
          component: () => import('../view/provider/orderDetail.vue'),
        },
        //采购订单详情
        {
          path: 'purchaseOrderDetail',
          name: 'purchaseOrderDetail',
          meta: {
            title: '订单详情',
            parentTitle: '采购订单',
            parentPath: 'provider',
          },
          component: () => import('../view/provider/purchaseOrderDetail.vue'),
        },
      ],
    },
    // 软件货架
    {
      path: '/management',
      name: 'management',
      meta: { title: '软件货架' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/management/software',
      children: [
        // 软件货架页面
        {
          path: 'software',
          name: 'software',
          component: () => import('../view/management/Index.vue'),
        },
        //软件货架-新增
        {
          path: 'shelfincrease',
          name: 'shelfincrease',
          meta: { title: '新增' },
          component: () => import('../view/shelfincrease/Index.vue'),
        },
        //软件货架-详情
        {
          path: 'softwaredetail',
          name: 'softwaredetail',
          meta: { title: '详情' },
          component: () => import('../view/management/content/softwareDetail.vue'),
        },
      ],
    },
    // 设备货架
    {
      path: '/equipment',
      name: 'Equipment',
      meta: { title: '设备货架' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/equipment/equipmentManage',
      children: [
        // 设备货架页面
        {
          path: 'equipmentManage',
          name: 'equipmentManage',
          component: () => import('../view/equipment/Index.vue'),
        },
        //软件货架-新增
        {
          path: 'shelfincrease',
          name: 'shelfincrease',
          meta: { title: '新增' },
          component: () => import('../view/shelfincrease/Index.vue'),
        },
        //软件货架-详情
        {
          path: 'softwaredetail',
          name: 'softwaredetail',
          meta: { title: '详情' },
          component: () => import('../view/management/content/softwareDetail.vue'),
        },
      ],
    },
    //资产管理
    {
      path: '/assets_manage',
      name: 'assets_manage',
      meta: { title: '资产管理' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/assets_manage/assetmanagement',
      children: [
        //资产管理
        {
          path: 'assetmanagement',
          name: 'assetmanagement',
          meta: { title: '资产概览' },
          component: () => import('../view/worktable/assetmanagement/Index.vue'),
        },
        // 无形资产
        {
          path: 'intanassets',
          name: 'intanassets',
          meta: { title: '无形资产' },
          component: () => import('../view/intanassets/Index.vue'),
        },
        // 无形资产-新增/编辑
        {
          path: 'intanassetsAdd',
          name: 'intanassetsAdd',
          meta: {
            title: '新增',
            parentTitle: '无形资产',
            parentPath: 'intanassets',
          },
          component: () => import('../view/intanassets/intanassetsAdd.vue'),
        },
        // 无形资产-详情
        {
          path: 'intanassetsDetail',
          name: 'intanassetsDetail',
          meta: {
            title: '详情',
            parentTitle: '无形资产',
            parentPath: 'intanassets',
          },
          component: () => import('../view/intanassets/intanassetsDetail.vue'),
        },
        // 固定资产
        {
          path: 'fixassets',
          name: 'fixassets',
          meta: { title: '固定资产' },
          component: () => import('../view/fixassets/Index.vue'),
        },
        // 固定资产-新增/编辑
        {
          path: 'fixassetsAdd',
          name: 'fixassetsAdd',
          meta: {
            title: '新增',
            parentTitle: '固定资产',
            parentPath: 'fixassets',
          },
          component: () => import('../view/fixassets/fixassetsAdd.vue'),
        },
        // 固定资产-详情
        {
          path: 'fixassetsDetail',
          name: 'fixassetsDetail',
          meta: {
            title: '详情',
            parentTitle: '固定资产',
            parentPath: 'fixassets',
          },
          component: () => import('../view/fixassets/fixassetsDetail.vue'),
        },
        // 数据资产
        {
          path: 'dataassets',
          name: 'dataassets',
          meta: { title: '数据资产' },
          component: () => import('../view/dataassets/Index.vue'),
        },
        // 数据资产-新增/编辑
        {
          path: 'dataassetsAdd',
          name: 'dataassetsAdd',
          meta: {
            title: '新增',
            parentTitle: '数据资产',
            parentPath: 'dataassets',
          },
          component: () => import('../view/dataassets/dataassetsAdd.vue'),
        },
        // 数据资产-详情
        {
          path: 'dataassetsDetail',
          name: 'dataassetsDetail',
          meta: {
            title: '详情',
            parentTitle: '数据资产',
            parentPath: 'dataassets',
          },
          component: () => import('../view/dataassets/dataassetsDetail.vue'),
        },
      ],
    },
    //财务管理
    {
      path: '/financial_manage',
      name: 'financial_manage',
      meta: { title: '财务管理' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/financial_manage/walletassets',
      children: [
        {
          path: 'walletassets',
          name: 'walletassets',
          meta: { title: '账户概览' },
          component: () => import('../view/worktable/walletassets/Index.vue'),
        },
        {
          path: 'invoice',
          name: 'invoice',
          meta: { title: '我要开票' },
          component: () => import('../view/worktable/walletassets/invoice.vue'),
        },
        {
          path: 'bankCard',
          name: 'bankCard',
          meta: {
            title: '提现',
            parentTitle: '账户概览',
            parentPath: 'walletassets',
          },
          component: () => import('../view/worktable/walletassets/bankCard.vue'),
        },
        {
          path: 'myBankCard',
          name: 'myBankCard',
          meta: { title: '银行卡管理' },
          component: () => import('../view/worktable/walletassets/myBankCard.vue'),
        },
        {
          path: 'addBankCard',
          name: 'addBankCard',
          meta: {
            title: '添加银行卡',
            parentTitle: '银行卡管理',
            parentPath: 'myBankCard',
          },
          component: () => import('../view/worktable/walletassets/addBankCard.vue'),
        },
        {
          path: 'balanceDetail',
          name: 'balanceDetail',
          meta: { title: '收支明细' },
          component: () => import('../view/worktable/walletassets/balanceDetail.vue'),
        },
      ],
    },
    // 课程管理
    {
      path: '/shelf',
      name: 'shelf',
      meta: { title: '课程管理' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/shelf/attendCourse',
      children: [
        {
          path: 'attendCourse',
          name: 'attendCourse',
          meta: { title: '我参加的课程' },
          component: () => import('../view/shelf/attendCourse.vue'),
        },
        {
          path: 'createCourse',
          name: 'createCourse',
          meta: { title: '我开办的课程' },
          component: () => import('../view/shelf/createCourse.vue'),
        },
        {
          path: 'createNewsAdd',
          name: 'createNewsAdd',
          meta: { title: '新增' },
          component: () => import('../view/shelf/content/Index.vue'),
        },
      ],
    },
    //  股权合作
    {
      path: '/cooperation',
      name: 'cooperation',
      meta: { title: '股权合作' },
      component: () => import('../view/worktable/Index.vue'),
      redirect: '/cooperation/cooperationPage',
      children: [
        {
          path: 'cooperationPage',
          name: 'cooperationPage',
          component: () => import('../view/cooperation/index.vue'),
        },
        //股权合作意向书
        {
          path: 'letter',
          name: 'letter',
          meta: { title: '股权详情' },
          component: () => import('../view/cooperation/letter.vue'),
        },
      ],
    },
    // 会员权益
    {
      path: '/members',
      name: 'Members',
      component: () => import('../view/members/Index.vue'),
    },

    //开源社区-热门软件
    {
      path: '/community',
      name: 'Community',
      component: () => import('../view/community/HotSoftware.vue'),
    },
    //开源社区-热门资讯
    {
      path: '/hotConsult',
      name: 'HotConsult',
      component: () => import('../view/community/HotConsult.vue'),
    },
    {
      path: '/opensource',
      name: 'OpenSource',
      component: () => import('../view/community/SoftContent.vue'),
    },
    {
      path: '/opensourcesoft',
      name: 'OpenSourceSoft',
      component: () => import('../view/community/source/SoftDetail.vue'),
    },
    {
      path: '/opensourcenews',
      name: 'OpenSourceNews',
      component: () => import('../view/community/source/NewsDetail.vue'),
    },

    {
      path: '/setnews',
      name: 'SetNews',
      component: () => import('../view/community/content/SetNews.vue'),
    },
    {
      path: '/setsoft',
      name: 'SetSoft',
      component: () => import('../view/community/content/SetSoft.vue'),
    },
    {
      path: '/transference',
      name: 'Transference',
      redirect: 'transference/copyright',
      component: () => import('../view/enterpirse/Transference.vue'),
      children: [
        {
          path: 'copyright',
          name: 'Copyright',
          component: () => import('../view/enterpirse/tran/copyright.vue'),
        },
        {
          path: 'logo',
          name: 'Logo',
          component: () => import('../view/enterpirse/tran/Logo.vue'),
        },
        {
          path: 'patent',
          name: 'Patent',
          component: () => import('../view/enterpirse/tran/patent.vue'),
        },
      ],
    },
    {
      path: '/transferencedetail',
      name: 'TransferenceDetail',
      component: () => import('../view/enterpirse/commodity/Index.vue'),
    },
    // 社区智慧食堂
    {
      path: '/commwisdom',
      name: 'Commwisdom',
      component: () => import('../view/commwisdom/index.vue'),
    },
    // 信息收取弹窗
    {
      path: '/fillInFrom',
      name: 'FillInFrom',
      component: () => import('../components/FillInFrom.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = store.state.user.token;

  if (to.path != '/home' && !token) {
    if (to.path == '/login') {
      next();
    } else {
      next();
    }
  } else {
    //如果已经登录 获取当前用户是否补全信息
    if (to.path == '/login' && token) {
      next();
    } else {
      next();
    }
  }
});

//全局后置路由守卫————初始化的时候被调用、每次路由切换之后被调用
router.afterEach((to, from) => {
  // console.log('后置路由守卫',to,from)
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js